import cn from 'classnames';
import { FC } from 'react';

import { DocumentSection } from '@/shared/api/transcriptor/transcriptorApi';
import { Icon } from '@/shared/ui';

import { getDocumentSectionContent } from '../lib/getDocumentSectionContent';

import styles from './EvaluationSections.module.scss';

type EvaluationSectionsProps = {
  sections: DocumentSection[];
  className?: string;
};

const ScoreBadge: FC<{ score: number }> = ({ score }) => (
  <span className={styles.scoreBadge}>
    <Icon name="starFilled" size={12} className={styles.scoreBadgeIcon} />
    {score}
  </span>
);

export const EvaluationSections: FC<EvaluationSectionsProps> = (props) => {
  const { sections, className } = props;

  const withContent = sections.filter(
    (section) =>
      Boolean(getDocumentSectionContent(section)) || section.score != null,
  );

  if (withContent.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(styles.container, className)}
      data-component="evaluation-sections"
    >
      {withContent.map((section, index) => (
        <section
          key={section.code ?? `evaluation-${index}`}
          className={styles.section}
        >
          <div className={styles.header}>
            <h3 className={styles.title}>{section.title}</h3>
            {typeof section.score === 'number' && (
              <ScoreBadge score={section.score} />
            )}
          </div>
          <p className={styles.content}>{getDocumentSectionContent(section)}</p>
        </section>
      ))}
    </div>
  );
};
